import classRoomImg from "../../../../assets/img/teacherDashboard/Classroom.png";
import "../classroom/Classroom.css";
import QuizOverviewTable from "./QuizOverviewTable";

const QuizOverview = () => {
  return (
    <div className="classroom-cnt">
      <div className="classroom-container">
        <img src={classRoomImg} className="img" alt="Quiz" />
        <h2 className="text">Quiz Limit Overview</h2>
      </div>
      <div>
        <QuizOverviewTable />
      </div>
    </div>
  );
};

export default QuizOverview;
